import { Locale } from "../config";
import { messages } from "../constants/app-messages";

export function getMessages(locale: Locale) {
  return messages[locale];
}
